export const FRAME_TYPES = {
  normal: {
    canvas: {
      w: 1200,
      h: 1200,
    },

    photoBox: {
      x: 215,
      y: 215,
      w: 770,
      h: 770,
    },
  },

  house: {
    canvas: {
      w: 1450,
      h: 1700,
    },

    photoBox: {
      x: 329,
      y: 730,
      w: 780,
      h: 780,
    },
  },
};

const COLOR_MAP = {
  rojo: "#d13a30",
  azul: "#467ab7",
  marino: "#2b4aae",
  blanco: "#ffffff",
  cian: "#d95095",
  amarillo: "#f7d717",
  naranja: "#f9882f",
  negro: "#000000",
  purpura: "#7066b5",
  rosa: "#ef6477",
  muerdago: "#3f7a5d",
  verde: "#59b969",
};

const createVariants = (folder, model, colors) => {
  return colors.map((color) => ({
    id: `${model}-${color}`,
    name: color.charAt(0).toUpperCase() + color.slice(1),
    swatch: COLOR_MAP[color],
    frameSrc: `/images/frames/${folder}/${model}-${color}.png`,
  }));
};

export const FRAMES = [
  {
    id: "aura",
    name: "aura",
    type: "normal",

    variants: createVariants("aura", "aura", [
      "rojo",
      "azul",
      "marino",
      "blanco",
      "cian",
      "naranja",
       "amarillo",
      "negro",
      "purpura",
      "rosa",
      "muerdago",
      "verde",
    ]),
  },

   {
    id: "velvet",
    name: "velvet",
    type: "normal",

    variants: createVariants("velvet", "velvet", [
      "rojo",
      "azul",
      "marino",
      "blanco",
      "amarillo",
      "cian",
      "naranja",
      "negro",
      "purpura",
      "rosa",
      "muerdago",
      "verde",
    ]),
  },

     {
    id: "nova",
    name: "nova",
    type: "normal",

    variants: createVariants("nova", "nova", [
      "rojo",
      "azul",
      "marino",
      "blanco",
      "amarillo",
      "cian",
      "naranja",
      "negro",
      "purpura",
      "rosa",
      "muerdago",
      "verde",
    ]),
  },

       {
    id: "deluxe",
    name: "deluxe",
    type: "normal",

    variants: createVariants("deluxe", "deluxe", [
      "rojo",
      "azul",
      "marino",
      "blanco",
      "amarillo",
      "cian",
      "naranja",
      "negro",
      "purpura",
      "rosa",
      "muerdago",
      "verde",
    ]),
  },

         {
    id: "kairo",
    name: "kairo",
    type: "normal",

    variants: createVariants("kairo", "kairo", [
      "rojo",
      "azul",
      "marino",
      "blanco",
      "amarillo",
      "cian",
      "naranja",
      "negro",
      "purpura",
      "rosa",
      "muerdago",
      "verde",
    ]),
  },

           {
    id: "estandar",
    name: "estandar",
    type: "normal",

    variants: createVariants("estandar", "estandar", [
      "rojo",
      "azul",
      "marino",
      "blanco",
      "amarillo",
      "cian",
      "naranja",
      "negro",
      "purpura",
      "rosa",
      "muerdago",
      "verde",
    ]),
  },

             {
    id: "line",
    name: "line",
    type: "normal",

    variants: createVariants("line", "line", [
      "rojo",
      "azul",
      "marino",
      "blanco",
      "amarillo",
      "cian",
      "naranja",
      "negro",
      "purpura",
      "rosa",
      "muerdago",
      "verde",
    ]),
  },

  {
    id: "hogar",
    name: "hogar",
    type: "house",

    variants: createVariants("hogar", "hogar", [
      "rojo",
      "azul",
      "marino",
      "blanco",
      "amarillo",
      "cian",
      "naranja",
      "negro",
      "purpura",
      "rosa",
      "muerdago",
      "verde",
    ]),
  },

   {
    id: "latidos",
    name: "latidos",
    type: "house",

    variants: createVariants("latidos", "latidos", [
      "rojo",
      "azul",
      "marino",
      "blanco",
      "amarillo",
      "cian",
      "naranja",
      "negro",
      "purpura",
      "rosa",
      "muerdago",
      "verde",
    ]),
  },

  {
    id: "guau",
    name: "guau",
    type: "house",

    variants: createVariants("guau", "guau", [
      "rojo",
      "azul",
      "marino",
      "blanco",
      "amarillo",
      "cian",
      "naranja",
      "negro",
      "purpura",
      "rosa",
      "muerdago",
      "verde",
    ]),
  },

    {
    id: "doggy",
    name: "doggy",
    type: "house",

    variants: createVariants("doggy", "doggy", [
      "rojo",
      "azul",
      "marino",
      "blanco",
      "amarillo",
      "cian",
      "naranja",
      "negro",
      "purpura",
      "rosa",
      "muerdago",
      "verde",
    ]),
  },

     {
    id: "neko",
    name: "neko",
    type: "house",

    variants: createVariants("neko", "neko", [
      "rojo",
      "azul",
      "marino",
      "blanco",
      "amarillo",
      "cian",
      "naranja",
      "negro",
      "purpura",
      "rosa",
      "muerdago",
      "verde",
    ]),
  },

      {
    id: "casia",
    name: "casia",
    type: "house",

    variants: createVariants("casia", "casia", [
      "rojo",
      "azul",
      "marino",
      "blanco",
      "amarillo",
      "cian",
      "naranja",
      "negro",
      "purpura",
      "rosa",
      "muerdago",
      "verde",
    ]),
  },

];